import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "../../../../components/ui/card";

const Facilities: React.FC = () => {
	const facilities = [
		{
			id: "space",
			title: "学習スペース",
			description: "Wi-Fi完備の快適な学習環境",
			details: [
				"個人作業用デスク（10席）",
				"グループワーク用テーブル（2台）",
				"高速Wi-Fi環境",
				"電源完備",
			],
		},
		{
			id: "equipment",
			title: "利用可能機材",
			description: "必要な機材を無料で利用可能",
			details: [
				"プロジェクター",
				"ホワイトボード",
				"モニター（外部出力用）",
				"Webカメラ・マイク（オンライン参加用）",
			],
		},
		{
			id: "books",
			title: "書籍・教材",
			description: "各種学習教材を用意",
			details: [
				"プログラミング関連書籍",
				"デザイン関連書籍",
				"オンライン学習教材",
				"定期購読雑誌",
			],
		},
	];

	return (
		<section className="mb-16">
			<h2 className="text-3xl font-semibold mb-6">学習環境・設備</h2>
			<div className="grid md:grid-cols-3 gap-6">
				{facilities.map((facility) => (
					<Card key={facility.id}>
						<CardHeader>
							<CardTitle>{facility.title}</CardTitle>
							<CardDescription>{facility.description}</CardDescription>
						</CardHeader>
						<CardContent>
							<ul className="list-disc list-inside space-y-2 text-sm text-gray-600">
								{facility.details.map((detail) => (
									<li key={detail}>{detail}</li>
								))}
							</ul>
						</CardContent>
					</Card>
				))}
			</div>
		</section>
	);
};

export default Facilities;
